import React, { useMemo } from "react";
import { translate } from "../../../../../common/providers";
import { icon, IconComponent } from "../../../../../common/components";
import styles from "./TabHeaders.module.css";

export default function TabHeaders({
	hasActions = true,
	simpleFlex = false,
	sortDirection,
	sortKey,
	tabs = [],
	visibleTabKeys = null,
	columnWidths = {},
	onClickSort,
	onResizeStart,
}) {
	const isKeySorting = useMemo(() => ["id", "name"].includes(sortKey), [sortKey]);
	const visibleTabs = useMemo(
		() =>
			Array.isArray(visibleTabKeys) && visibleTabKeys.length > 0
				? tabs.filter((tab) => visibleTabKeys.includes(tab.key || tab.name))
				: tabs,
		[tabs, visibleTabKeys]
	);
	const getColumnStyle = (tab) => {
		if (simpleFlex) {
			return { flex: "1 1 0", minWidth: 0 };
		}
		const width = columnWidths[tab.key || tab.name];
		if (width === 0) {
			return { flex: "1 1 auto", minWidth: 0 };
		}
		return { flex: `0 0 ${width || 120}px`, width: `${width || 120}px`, minWidth: `${width || 120}px` };
	};
	return (
		<div className={styles.main}>
			{visibleTabs.map((tab, index) => {
				const columnKey = tab.key || tab.name;
				const content =
					index === 0 ? (
						<div
							className={`${styles.sortLabel} ${styles.column} ${
								index === 0 ? styles["column--first"] : ""
							}`}
							data-simple-flex={simpleFlex}
							role="presentation"
							onClick={() => onClickSort(tab.sortKey)}
						>
							{translate(tab.name)}
							{!isKeySorting && (
								<IconComponent
									className={`${styles.icon} ${styles["icon--inactive"]}`}
									icon={icon.faSort}
								/>
							)}
							{isKeySorting &&
								((sortDirection === "asc" && (
									<IconComponent className={styles.icon} icon={icon.faSortUp} />
								)) ||
									(sortDirection === "desc" && (
										<IconComponent className={styles.icon} icon={icon.faSortDown} />
									)))}
						</div>
					) : (
						<div
							className={`${styles.column} ${index === 0 ? styles["column--first"] : ""}`}
							data-simple-flex={simpleFlex}
						>
							{translate(tab.name)}
						</div>
					);

				return (
					<div key={columnKey} className={styles.columnWrapper} style={getColumnStyle(tab)}>
						{content}
						{typeof onResizeStart === "function" && index < visibleTabs.length - 1 && (
							<div
								className={styles.resizeHandle}
								role="presentation"
								onMouseDown={(event) => onResizeStart(event, columnKey)}
							/>
						)}
					</div>
				);
			})}
			{hasActions && <div className={styles.actionsSpacer} />}
		</div>
	);
}
